var mp = mp || {};

// FancyBox
//-----------------------------------------------------------------
mp.fancyBox = function() {
    var $trigger = $("[data-fancybox]");

    if (!$trigger.length) {
        return;
    }
    
    $trigger.fancybox({
        touch: true,
        infobar: false,
        buttons: [
            "close"
        ],
    });
};



// Tabs
//-----------------------------------------------------------------
mp.tabs = function() {
    var $element = $(".tabs");

    if (!$element.length) {
        return;
    }

    $(document).on('click', '.tabs [data-toggle]', function(e){
        e.preventDefault();
        
        var $tabID = $(this).data("toggle");

        $(this).parents('.tabs').find("[data-toggle], .tabs__content").removeClass("active");
        
        $(this).parents('.tabs').find(".tabs__nav [data-toggle='"+$tabID+"']").addClass("active");
        $(this).parents('.tabs').find("#"+$tabID).addClass("active");
    })
};



// Toggle
//-----------------------------------------------------------------
mp.toggle = function() {
    var $element = $("[data-toggle]");

    if (!$element.length) {
        return;
    }

    $(document).on('click', '[data-toggle]', function(e){
        e.preventDefault();
        
        $target = $(this).data("toggle");
        $('[data-toggle], [data-toggle-content]').removeClass('active');

        $(this).addClass("active");
        $('[data-toggle-content="'+$target+'"]').addClass("active");
    })
};



// ScrollTo
//-----------------------------------------------------------------
mp.scrollTo = function() {
    var $trigger = $("[data-scroll]");

    if (!$trigger.length) {
        return;
    }


    $.extend($.scrollTo.defaults, {
        axis: 'y',
        duration: 800,
        offset: -80,
    });

    $trigger.on('click', function(e) {
        //e.preventDefault();

        setTimeout(function(){
            scrollTo();
        }, 50);
    });

    scrollTo();

    function scrollTo() {
        $hash = $(location).attr('hash');

        if ($hash.length > 1) {
            $target = $hash.replace("#", "");
            $target = "#st_"+$target;
            $target = $($target);

            //console.log($target);

            setTimeout(function(){
                $.scrollTo($target);
            }, 100);

            $(".header .is_open").removeClass("is_open");
        }
    }
}




// Change Quantity
//-----------------------------------------------------------------
mp.changeQuantity = function() {
    var $element = $(".reservation");

    if (!$element.length) {
        return;
    }


    $(document).on('click', '.reservation .plus', function(e){
        e.preventDefault();

        $input = $(this).parent().find("input");
        $input_val = parseInt($input.val()) + 1;

        $input_name = $input.attr("name");

        if ($input_name == "pets" && $input_val > 2) {
            return;
        }

        if ($input_name == "adults" || $input_name == "children") {
            $form = $(this).parents("form").serializeArray();

            $adults_val = $form.filter(function (item) { return item.name == "adults" });
            $adults_val = parseInt($adults_val[0]["value"]);

            $children_val = $form.filter(function (item) { return item.name == "children" });
            $children_val = parseInt($children_val[0]["value"]);


            if (($adults_val + $children_val) >= 10) {
                return;
            } 
        }
        
        $input.val($input_val);
        updateTotalGuests();
    })

    $(document).on('click', '.reservation .minus', function(e){
        e.preventDefault();

        $input = $(this).parent().find("input");
        $input_val = parseInt($input.val());
        $input_name = $input.attr("name");

        if ($input_name == "adults" && $input_val < 2) {
            return;
        }

        if ($input_val > 0) {
            $input_val = $input_val - 1;
        }
        
        $input.val($input_val);
        updateTotalGuests();
    })

    function updateTotalGuests() {
        $form = $("#reservation__form").serializeArray();

        $adults_val = $form.filter(function (item) { return item.name == "adults" });
        $adults_val = parseInt($adults_val[0]["value"]);

        $children_val = $form.filter(function (item) { return item.name == "children" });
        $children_val = parseInt($children_val[0]["value"]);

        $pets_val = $form.filter(function (item) { return item.name == "pets" });
        $pets_val = parseInt($pets_val[0]["value"]);

        $total_guests = $adults_val + $children_val + $pets_val;

        $("#reservation__form input[name='total_guests']").val($total_guests).focus();
    }


    $("#reservation__form input[name='total_guests']").on('click',function(e) {
        e.preventDefault();

        window.setTimeout(function() {
            $("#reservation__form .reservation__dropdown").addClass('active');
        }, 10);
    });

    $(document).click(function(e){
        if ($(e.target).closest('.reservation__dropdown').length != 0) {
            return false;
        }
        
        $('.reservation__dropdown').removeClass("active");
    });
};




// Datepicker
//-----------------------------------------------------------------
mp.datepicker = function() {
    var $element = $("[data-datepicker]");

    if (!$element.length) {
        return;
    }


    $element.datepicker({
        autoclose: true,
        weekStart: 1,
        orientation: "auto bottom",
        startDate: "today",
        todayHighlight: true
    });
};







$(document).ready(function (){
    mp.fancyBox();
    mp.tabs();
    mp.toggle();
    mp.scrollTo();
    mp.changeQuantity();
    mp.datepicker();
});